export default __webpack_public_path__ + "static/media/placeholder.31d6cfe0.mp4";